"use client";

import * as React from "react";
import { NextUIProvider } from "@nextui-org/system";
import { UserContextProvider } from "../contexts/UserContext";

export function Providers({ children }) {
  return (
    <NextUIProvider className="">
      <UserContextProvider>
        {children}
      </UserContextProvider>
    </NextUIProvider>
  );
}
